module.exports = __webpack_public_path__ + "static/favicon-73a832cc685cd61cc20a12cca281b69a.ico";